/**
 * Reusable stateless form component for Course
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import { EditorState, convertToRaw } from 'draft-js';

import videoUtils from "../../../global/utils/videoUtils.js";
import Video from "../../../global/components/helpers/Video.js.jsx";

// import form components
import {
  CdnPathInput
  , RadioInput
  , RichEditor
  , SelectFromArray
  , SelectFromObject
  , TextInput
  , TextAreaInput
  , UrlInput
} from '../../../global/components/forms';

import CourseObjectListComparator from './CourseObjectListComparator.js.jsx'; 

function CourseForm({
  allSponsors
  , allStudies
  , cancelLink
  , course
  , formHelpers
  , formTitle
  , formType
  , fromStudy
  , handleFormChange
  , handleFormSubmit
  , contentModules
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Course" : "Update Course";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;
  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="course.courseForm" className="course-form" onSubmit={handleFormSubmit}>
            {header}
            <div className="-form-step"><span className="-num">1</span> General info</div>
            <div className="yt-col full m_60">
              <TextInput
                change={handleFormChange}
                label="Title"
                name="course.title"
                placeholder="i.e. Example Course 1"
                required={true}
                value={course.title}
              />
              <TextInput
                change={handleFormChange}
                label="Cononical URL Slug"
                name="course.slug"
                placeholder="i.e. example-course-1"
                required={true}
                value={course.slug}
              />
              <TextAreaInput
                change={handleFormChange}
                helpText={<span>{course.summary.length} of 180</span>}
                label="Brief summary"
                maxLength="180"
                name="course.summary"
                required={true}
                rows="3"
                value={course.summary}
              />
            </div>
            {/* <div className="yt-col full m_30">
              <SelectFromArray
                change={handleFormChange}
                helpText={"Only 'Published' Statuses will show up to the user!"}
                items={formHelpers.statuses}
                label={"Status"}
                name="course.status"
                required={true}
                value={course.status}
              />
            </div> */}
            <div className="-form-step"><span className="-num">2</span> Media</div>
            <div className="yt-col full m_60">
              <CdnPathInput
                change={handleFormChange}
                label="Trailer Video Path"
                name="course.trailerVidPath"
                required={false}
                validate={false}
                value={course.trailerVidPath}
                />
              <CdnPathInput
                change={handleFormChange}
                label="Trailer Poster Path"
                name="course.trailerPosterPath"
                required={false}
                validate={false}
                value={course.trailerPosterPath}
              />
            </div>
            <div className="-form-step"><span className="-num">3</span> Assign Sponsor & Study</div>
            <div className="yt-col full m_30">
              <SelectFromObject
                change={handleFormChange}
                clearable={false}
                disabled={fromStudy}
                display={'name'}
                filterable={true}
                label="Sponsor"
                name="course._organization"
                objects={allSponsors}
                placeholder="-- Select a Sponsor --"
                required={true}
                selected={course._organization}
                value={'_id'}
              />
                { course._organization ?
                  <SelectFromObject
                    change={handleFormChange}
                    clearable={false}
                    disabled={fromStudy}
                    display={'name'}
                    filterable={true}
                    label={"Study"}
                    name="course._group"
                    objects={allStudies}
                    placeholder="-- Select a Study --"
                    required={true}
                    selected={course._group}
                    value={'_id'}
                    />
                    :
                    null
                  }
            </div>
            { course._organization && course._group ?
              <div>
                <div className="-form-step"><span className="-num">4</span> Assign specific content modules</div>
                <CourseObjectListComparator
                  change={handleFormChange}
                  displayKey={"title"}
                  filterable={true}
                  items={contentModules}
                  label="Content Modules "
                  name="course._contentModules"
                  placeholder="Content Modules"
                  reorderable={true}
                  required={true}
                  selected={course._contentModules}
                  valueKey={"_id"}
                />
                <RadioInput
                  helpText={
                        <span>Note: Only for <strong>ProKidney</strong>. This will be replaced with new London functionality soon. Default is no.</span>
                  }
                  label="Modules must be taken in order above."
                  options={[
                    { val: 'yes', display: 'Yes' },
                    { val: 'no', display: 'No' },
                  ]}
                  name="formHelpers.ordered"
                  value={formHelpers.ordered}
                  change={handleFormChange}
                  inLine={true}
                />
              </div>
              :
                null
            }
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                { course.title.length > 0 && course._organization && course._group && formHelpers.statuses.indexOf(course.status) > -1 ?
                    <button className="yt-btn " type="submit" > {buttonText} </button>
                  :
                    null
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

CourseForm.propTypes = {
  allSponsors: PropTypes.array.isRequired
  , allStudies: PropTypes.array.isRequired
  , cancelLink: PropTypes.string.isRequired
  , course: PropTypes.object.isRequired
  , formHelpers: PropTypes.object.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , fromStudy: PropTypes.bool
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , contentModules: PropTypes.array.isRequired
}

CourseForm.defaultProps = {
  formTitle: ''
  , fromStudy: false
}

export default CourseForm;



// WEBPACK FOOTER //
// modules/course/components/CourseForm.js.jsx